var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFaceSmileSolid = function SvgFaceSmileSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-6.1 4.2a1 1 0 0 1 1.397.196l.005.006.033.041a4.945 4.945 0 0 0 .815.748c.578.42 1.376.81 2.35.81.975 0 1.772-.39 2.35-.81a4.945 4.945 0 0 0 .815-.748l.034-.041.004-.006A1 1 0 0 1 16.8 14.6l-.103.129c-.059.07-.142.164-.248.276a6.951 6.951 0 0 1-.923.804c-.798.58-2 1.191-3.526 1.191-1.525 0-2.728-.61-3.526-1.191a6.949 6.949 0 0 1-1.17-1.08A4.25 4.25 0 0 1 7.2 14.6a1 1 0 0 1 .2-1.4Z",
    fill: "currentcolor"
  })));
};
export default SvgFaceSmileSolid;